<template>
  <div class="item-container">
    <div class="type-label">{{ state.questionType }}</div>
    <div class="question-container">
      <div class="question-header">
        <div class="question-number">
          {{ titleIndex + 1 }}{{ biaodian }}{{ state.caseProblem }}
        </div>
        <div class="question-statistics">
          <div>
            填写率: {{ state.dataObj.completionRate }}% / 填写人数:
            {{ state.dataObj.validResponses }}人
          </div>
        </div>
      </div>

      <div
        class="question-block"
        v-for="(item, index) in state.questionList"
        :key="index"
      >
        <div class="question-content-row">
          <!-- 左侧：选项 -->
          <div class="option-box">
            <div
              class="option-item"
              v-for="(subItem, subIndex) in item.list"
              :key="subIndex"
            >
              <div v-if="state.questionType === '评星'">
                <el-rate
                  v-model="subItem.text"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template="{value}"
                />
              </div>
              <div v-else class="option-text">
                {{ subItem.text }}
                <span class="option-percentage">{{ subItem.percentage }}%</span>
              </div>
              <div class="option-stat">{{ subItem.count }}人</div>
            </div>
          </div>

          <!-- 右侧：图表 -->
          <div class="echarts-new">
            <div
              style="
                display: flex;
                justify-content: flex-end;
                padding-right: 47px;
                width: 530px;
              "
            >
              <div
                v-for="icon in state.icons"
                :key="icon.type"
                style="width: 50px; height: 30px"
                @click="
                  item.iconType = icon.type;
                  drawChart(item, index);
                "
              >
                <el-image
                  style="width: 50px; height: 30px"
                  :src="
                    icon.type === item.iconType
                      ? icon.selected
                      : icon.unselected
                  "
                  mode="aspectFit"
                  fit="fill"
                />
              </div>
            </div>

            <div
              v-show="item.iconType === 'line'"
              :id="`LineChart${titleIndex}-${index}`"
              style="width: 530px; height: 250px"
            ></div>
            <div
              v-show="item.iconType === 'column'"
              :id="`ColumnChart${titleIndex}-${index}`"
              style="width: 530px; height: 250px"
            ></div>
            <div
              v-show="item.iconType === 'ring'"
              :id="`RingChart${titleIndex}-${index}`"
              style="width: 530px; height: 250px"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { QuestionType } from "@/components/constant.js";

export default {
  name: "AnalysisChart",
  props: {
    dataObj: {
      type: Object,
      default: () => ({}),
    },
    titleIndex: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      biaodian: "、",
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      state: {
        dataObj: {},
        caseProblem: "",
        questionType: "",
        questionList: [],
        icons: [
          {
            selected:
              "https://ossfastmake.mustke.com/qrCode/tupian/1744189110374.svg",
            unselected:
              "https://ossfastmake.mustke.com/qrCode/tupian/1744189084199.svg",
            type: "line",
          },
          {
            selected:
              "https://ossfastmake.mustke.com/qrCode/tupian/1744189145612.svg",
            unselected:
              "https://ossfastmake.mustke.com/qrCode/tupian/1744189130823.svg",
            type: "column",
          },
          {
            selected:
              "https://ossfastmake.mustke.com/qrCode/tupian/1744189184460.svg",
            unselected:
              "https://ossfastmake.mustke.com/qrCode/tupian/1744189163252.svg",
            type: "ring",
          },
        ],
      },
    };
  },

  watch: {
    dataObj: {
      handler(newValue) {
        this.state.dataObj = JSON.parse(newValue.analyzer || "{}");
        this.state.caseProblem = newValue.caseProblem || "";

        // const type = newValue.type;
        if (newValue.type === this.QuestionType.SCQ) {
          this.state.questionType = "单选";
        }
        if (newValue.type === this.QuestionType.MCQ) {
          this.state.questionType = "多选";
        }
        if (newValue.type === this.QuestionType.SBQ) {
          this.state.questionType = "填空";
        }
        if (newValue.type === this.QuestionType.MBQ) {
          this.state.questionType = "多项填空";
        }
        if (newValue.type === this.QuestionType.DLQ) {
          this.state.questionType = "下拉";
        }
        if (newValue.type === this.QuestionType.NPS) {
          this.state.questionType = "NPS";
        }
        if (newValue.type === this.QuestionType.VOTE) {
          this.state.questionType = "投票";
        }
        if (newValue.type === this.QuestionType.SORT) {
          this.state.questionType = "排序";
        }
        if (newValue.type === this.QuestionType.REMARK) {
          this.state.questionType = "备注";
        }
        if (newValue.type === this.QuestionType.SCORE) {
          this.state.questionType = "评分";
        }
        if (newValue.type === this.QuestionType.QA) {
          this.state.questionType = "问答";
        }
        if (newValue.type === this.QuestionType.WRQ) {
          this.state.questionType = "权重评分";
        }
        if (newValue.type === this.QuestionType.SRQ) {
          this.state.questionType = "评星";
        }
        if (newValue.type === this.QuestionType.NAME) {
          this.state.questionType = "姓名";
        }
        if (newValue.type === this.QuestionType.GENDER) {
          this.state.questionType = "性别";
        }
        if (newValue.type === this.QuestionType.AGE) {
          this.state.questionType = "年龄";
        }
        if (newValue.type === this.QuestionType.TEL) {
          this.state.questionType = "电话";
        }
        if (newValue.type === this.QuestionType.EMAIL) {
          this.state.questionType = "邮箱";
        }
        if (newValue.type === this.QuestionType.DATE) {
          this.state.questionType = "日期";
        }
        if (newValue.type === this.QuestionType.TIME) {
          this.state.questionType = "时间";
        }
        if (newValue.type === this.QuestionType.ADDR) {
          this.state.questionType = "地址";
        }
        if (newValue.type === this.QuestionType.DownloadFile) {
          this.state.questionType = "下载文件";
        }
        if (newValue.type === this.QuestionType.UploadFile) {
          this.state.questionType = "上传文件";
        }
        if (newValue.type === this.QuestionType.BDQ) {
          this.state.questionType = "出生日期";
        }
        if (newValue.type === this.QuestionType.IDQ) {
          this.state.questionType = "身份证号";
        }
        if (newValue.type === this.QuestionType.ELQ) {
          this.state.questionType = "学历";
        }
        if (newValue.type === this.QuestionType.WX) {
          this.state.questionType = "微信号";
        }
        if (newValue.type === this.QuestionType.MaxDiff) {
          this.state.questionType = "MaxDiff";
        }
        if (newValue.type === this.QuestionType.CASCADER) {
          this.state.questionType = "联级题";
        }
        if (newValue.type === this.QuestionType.IMAGE) {
          this.state.questionType = "图片上传";
        }
        if (newValue.type === this.QuestionType.TextDescription) {
          this.state.questionType = "文本描述";
        }
        if (newValue.type === this.QuestionType.EvaluationSCQ) {
          this.state.questionType = "单选";
        }
        if (newValue.type === this.QuestionType.EvaluationMCQ) {
          this.state.questionType = "多选";
        }
        if (newValue.type === this.QuestionType.EvaluationWRQ) {
          this.state.questionType = "权重评分";
        }
        if (newValue.type === this.QuestionType.EvaluationNPS) {
          this.state.questionType = "NPS";
        }
        if (newValue.type === this.QuestionType.EvaluationScore) {
          this.state.questionType = "分数评定";
        }
		if (newValue.type === this.QuestionType.TFQ) {
		  this.state.questionType = "判断";
		}
        // 处理多题或单题
        const rawQuestions = this.state.dataObj.questions;
        if (Array.isArray(rawQuestions) && rawQuestions.length > 0) {
          this.state.questionList = rawQuestions.map((q) =>
            this.buildQuestionItem(q),
          );
        } else {
          this.state.questionList = [
            this.buildQuestionItem(this.state.dataObj),
          ];
        }

        this.$nextTick(() => {
          this.state.questionList.forEach((qItem, index) => {
            this.drawChart(qItem, index);
          });
        });
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    buildQuestionItem(q) {
      const type = this.dataObj.type;
      let ops = q.distribution || this.state.dataObj.options || [];

      // 格式化字段
      if (
        [
          this.QuestionType.NPS,
          this.QuestionType.SCORE,
          this.QuestionType.WRQ,
          this.QuestionType.EvaluationNPS,
          this.QuestionType.EvaluationScore,
          this.QuestionType.EvaluationWRQ,
        ].includes(type)
      ) {
        ops.forEach((item) => {
          item.text = item.score;
          item.percentage = item.rate;
        });
      } else if (type === this.QuestionType.SRQ) {
        ops.forEach((item) => {
          item.text = item.star;
          item.percentage = item.rate;
        });
      }

      return {
        average: q.average,
        median: q.median,
        variance: q.variance,
        iconType: "line",
        list: ops,
        lineChartData: {
          categories: ops.map((option) =>
            option.text.length > 4
              ? option.text.slice(0, 4) + "..."
              : option.text,
          ),
          series: [
            {
              name: "折线图",
              data: ops.map((option) => option.count),
              color: "#3A60FF",
              type: "line",
            },
          ],
        },
        columnChartData: {
          categories: ops.map((option) =>
            option.text.length > 4
              ? option.text.slice(0, 4) + "..."
              : option.text,
          ),
          series: [
            {
              name: "",
              data: ops.map((option) => option.count),
              color: "#3A60FF",
              type: "bar",
            },
          ],
        },
        ringChartData: {
          series: [
            {
              data: ops.map((option) => ({
                name:
                  option.text.length > 4
                    ? option.text.slice(0, 4) + "..."
                    : option.text,
                value: option.count,
              })),
              type: "pie",
            },
          ],
        },
      };
    },

    drawChart(qItem, qIndex) {
      this.$nextTick(() => {
        const idSuffix = this.titleIndex + "-" + qIndex;
        const chartMap = {
          line: "LineChart",
          column: "ColumnChart",
          ring: "RingChart",
        };

        const id = chartMap[qItem.iconType] + idSuffix;
        const chart = this.$echarts.init(document.getElementById(id));

        if (qItem.iconType === "line") {
          chart.setOption({
            xAxis: {
              data: qItem.lineChartData.categories,
            },
            yAxis: {},
            series: qItem.lineChartData.series,
            tooltip: {},
            legend: {
              data: [""],
            },
          });
        } else if (qItem.iconType === "column") {
          chart.setOption({
            xAxis: {
              data: qItem.columnChartData.categories,
            },
            yAxis: {},
            series: qItem.columnChartData.series,
            tooltip: {},
            legend: {
              data: [""],
            },
          });
        } else if (qItem.iconType === "ring") {
          chart.setOption({
            series: qItem.ringChartData.series,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.item-container {
  background-color: #ffffff;
  width: 100%;
  /*padding: 30px;*/
  /* border-radius: 20px; */
  position: relative;
  margin-top: 20px;
  /*box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);*/
  display: flex;
}

.question-container {
  /* border: 1px solid #eee; */
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  /* width: 600px; */
  /* margin: 0 auto; */
  margin-top: 50px;
}

.question-header {
  display: flex;
  align-items: baseline;
  margin-bottom: 0.5rem;
  color: #2c3e50;
  justify-content: space-between;
  align-items: flex-end;
}

.question-number {
  font-weight: normal;
  font-size: 14px;
  word-break: break-all;
  font-family: auto;
  width: 530px;
  /* width: 420px; */
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 16px;
  border-radius: 8px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  gap: 10px;
}

.question-type {
  margin-right: 0.5rem;
  font-size: 14px;
}

.question-statistics {
  font-size: 12px;
  color: #666;
  margin-right: 72px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  background: #fff;
  /* padding: 16px; */
  border-radius: 8px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.question-statistics div {
  width: 530px;
  text-align: right;
  padding-right: 22px;
}

.question-input {
  margin-bottom: 1rem;
  padding: 0.8rem;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: #666;
  background-color: #f8f9fa;
  font-size: 14px;
}

.option-list {
  display: flex;
  flex-direction: column;
}

/* .option-box {
	display: flex;
	flex-direction: column;
	gap: 10px;
	
	&+.option-box {
		margin-top: 50px;
	}
} */

.option-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.option-text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px 30px 10px 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
  border: 1px solid rgba(188, 217, 255, 1);
  color: #1e80ff;
  font-size: 12px;
  position: relative;
}

.option-percentage {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0%, -50%);
  color: #333;
}

.option-stat {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 10px;
  white-space: nowrap;
  color: #333;
  font-size: 12px;
}

.chart-options {
  display: flex;
  /* justify-content: flex-end; */
  margin-top: 20rpx;
}

.type-label {
  color: #00c389;
  font-size: 16px;
  font-weight: bold;
  font-family: auto;
  background: linear-gradient(
    180deg,
    rgba(0, 179, 128, 0.11),
    rgba(0, 179, 128, 0)
  );
  /* border-radius: 7px 0 10px 0; */
  position: absolute;
  top: -20px;
  left: -20px;
  padding: 6px 17px 18px 17px;
  margin: 20px;
}

.echarts-new {
  /* margin-top: 20px; */
  padding-right: 20px;
  box-sizing: border-box;
}

.echarts-new > div > div {
  width: 30px !important;
  height: 30px !important;
  cursor: pointer;
}

.echarts-new > div > div .el-image {
  width: 30px !important;
  height: 30px !important;
}

.question-block {
  margin-bottom: 30px;
}

.question-content-row {
  display: flex;
  /* align-items: stretch;
  gap: 30px; */
  justify-content: space-between;
}

/* 左侧选项框 */
.option-box {
  width: 530px;
  flex: 1;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

/* 右侧图表框 */
.echarts-new {
  flex: 1;
  background: #fff;
  /* padding: 16px; */
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AnalysisChart.vue